module.exports = __webpack_public_path__ + "static/media/cherrybend.be4f3f09.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cherrybend.png
// module id = 101
// module chunks = 0